import React, { useContext } from 'react'
import { VideoContext } from '../context/VideoContext';
import { Positions, TextSizes } from '../constants/index';

const Interstitial = ({ children, position, textSize }) => {
  
  return (
    <div
      className={`overlay-container opacity-100 ${Positions.find((pos) => pos.type === position)?.className} flex min-h-full px-6 py-16 md:px-12 md:py-28 text-center items-center pointer-events-none`}
    >
      <div className={`overlay relative flex h-fit w-full md:w-fit lg:max-w-[70%] px-10 py-10 md:py-10 md:px-28 justify-center items-center bg-black bg-opacity-80 shadow-deepdive pointer-events-auto`}>

        <span className="corner w-[24.875px] h-[24.875px]  translate-y-[-1px] translate-x-[-1px] TL absolute bg-[url('./img/corner.svg')] -top-[4px] -left-[4px]"></span>
        <span className="corner w-[24.875px] h-[24.875px] translate-y-[-2px] TR absolute bg-[url('./img/corner.svg')] -top-[3px] -right-[4px] rotate-90"></span>
        <span className="corner  w-[24.875px] h-[24.875px] translate-y-[2px] BL absolute bg-[url('./img/corner.svg')] -bottom-[3px] -right-[5px] rotate-180"></span>
        <span className="corner w-[24.875px] h-[24.875px] translate-y-[1px] translate-x-[1px] BR absolute bg-[url('./img/corner.svg')] -bottom-[3px] -left-[5.5px] -rotate-90"></span>
        
        <span className={`font-bold text-white ${textSize} ${TextSizes.find(size => size.type === textSize)?.className ?? "Default value"}`}>
          {children}
        </span>
        
      </div>
    </div>
  );
};

export default Interstitial;